"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/scp-client-portal-icon-text.svg.js",
    _path,
    _g,
    _path2,
    _path3,
    _defs;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 161,
    height: 32,
    viewBox: "0 0 161 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M25.6 0H6.4A6.4 6.4 0 000 6.4v19.2A6.4 6.4 0 006.4 32h19.2a6.4 6.4 0 006.4-6.4V6.4A6.4 6.4 0 0025.6 0z",
    fill: "url(#prefix__paint0_linear_5535_35391)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  })), _g || (_g = React.createElement("g", {
    clipPath: "url(#prefix__clip0_5535_35391)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  }, React.createElement("path", {
    d: "M20.944 7.297v11.039l-3.426-1.98V5.312l2.645 1.534.781.451z",
    fill: "#B5BD00",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18
    },
    __self: this
  }), React.createElement("path", {
    d: "M20.164 6.847l-2.646 1.512-6.99 3.998-3.427-1.98 9.647-5.51.77.445 2.646 1.535z",
    fill: "#3E4323",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19
    },
    __self: this
  }), React.createElement("path", {
    d: "M20.389 19.288l-5.885 3.36-3.426 1.964-.314.176-.786-.457-2.635-1.523L9.978 21.3l1.1-.627 3.426-1.958 2.458-1.408 3.427 1.98z",
    fill: "#B5BD00",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23
    },
    __self: this
  }), React.createElement("path", {
    d: "M9.978 13.309v11.022l-2.635-1.523-.792-.457V11.329l3.427 1.98z",
    fill: "#3E4323",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27
    },
    __self: this
  }), React.createElement("path", {
    d: "M25.471 9.915v11.039l-3.426-1.98V7.93l2.65 1.534.776.451z",
    fill: "#A6B1A5",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28
    },
    __self: this
  }), React.createElement("path", {
    d: "M24.695 9.464l-2.65 1.518-1.1.633-3.427 1.958-2.459 1.408-3.426-1.986 5.885-3.36 3.426-1.958.33-.187.77.44 2.651 1.534z",
    fill: "#0D1F36",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29
    },
    __self: this
  }), React.createElement("path", {
    d: "M24.921 21.905l-9.63 5.506-.787-.457-2.634-1.523 2.634-1.507 6.996-3.993 3.421 1.974z",
    fill: "#A6B1A5",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33
    },
    __self: this
  }), React.createElement("path", {
    d: "M14.504 15.927v11.027l-2.635-1.523-.792-.462V13.947l3.427 1.98z",
    fill: "#0D1F36",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37
    },
    __self: this
  }))), _path2 || (_path2 = React.createElement("path", {
    d: "M40 10.966V6.02h1.152v.707c.204-.48.698-.805 1.317-.805.668 0 1.123.285 1.365.864.281-.58.814-.864 1.598-.864 1.075 0 1.695.756 1.695 1.982v3.062h-1.163V8.07c0-.676-.32-1.098-.872-1.098-.571 0-.968.47-.968 1.147v2.846h-1.151V8.071c0-.676-.32-1.098-.872-1.098-.542 0-.949.48-.949 1.147v2.846H40zm9.432.068l-2.004-5.015h1.19l1.423 3.611 1.463-3.61h1.19l-2.866 6.85h-1.18l.784-1.836zm20.045-6.267c-.51-.472-1.231-.721-2.092-.721h-1.63v6.957h1.153v-1.6h.477c.86 0 1.583-.247 2.09-.715.514-.474.786-1.15.786-1.954 0-.81-.272-1.49-.784-1.967zm-2.569.382h.44c1.155 0 1.74.534 1.74 1.585 0 1.039-.585 1.565-1.74 1.565h-.44V5.15zM55.941 6.973l-.51-.244c-.762-.363-.953-.513-.953-.949 0-.411.306-.688.762-.688.472 0 .776.17 1.016.57l.146.243.928-.601-.143-.233C56.748 4.35 56.108 4 55.231 4c-1.099 0-1.896.756-1.896 1.799 0 1.017.617 1.515 1.612 1.988l.511.244c.796.374 1.026.627 1.026 1.127 0 .513-.41.82-1.096.82-.617 0-1.117-.305-1.405-.856l-.129-.246-.995.53.129.248c.483.924 1.34 1.433 2.41 1.433.664 0 1.223-.178 1.618-.516.406-.348.62-.842.62-1.432 0-1.12-.648-1.66-1.695-2.166zm8.09 1.839l-.16.217c-.46.62-1.123.949-1.919.949-1.343 0-2.318-1.024-2.318-2.434 0-1.387.977-2.433 2.27-2.433.757 0 1.363.292 1.802.868l.164.214.907-.662-.17-.228C63.964 4.45 63.034 4 61.914 4c-1.973 0-3.46 1.523-3.46 3.543-.005.977.345 1.874.987 2.528.642.653 1.53 1.018 2.491 1.018 1.2 0 2.158-.467 2.849-1.388l.173-.23-.924-.66z",
    fill: "#CFCFCF",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39
    },
    __self: this
  })), _path3 || (_path3 = React.createElement("path", {
    d: "M44.74 26.68c-1.543 0-2.721-.426-3.534-1.276-.804-.85-1.206-2.058-1.206-3.623 0-.778.123-1.47.37-2.076a4.4 4.4 0 011.014-1.546 4.2 4.2 0 011.534-.964 5.584 5.584 0 011.932-.325c.402 0 .767.031 1.096.095.33.054.617.122.863.203a3.85 3.85 0 01.973.42l-.616 1.71a5.167 5.167 0 00-1.028-.393 4.843 4.843 0 00-1.315-.163c-.329 0-.653.054-.973.163a2.22 2.22 0 00-.836.529c-.237.235-.43.543-.575.923-.146.38-.22.84-.22 1.384 0 .434.046.84.138 1.22.1.372.255.693.465.964.22.271.503.489.85.651.347.154.767.231 1.26.231.31 0 .59-.018.836-.054a7.8 7.8 0 00.658-.122c.192-.055.36-.113.507-.177.146-.063.278-.122.397-.176l.59 1.696c-.302.18-.727.344-1.275.488-.548.145-1.183.218-1.904.218zM57.009 24.671v1.819h-6.344v-9.403h2.138v7.584h4.206zM59.756 17.087h2.137v9.403h-2.137v-9.403zM65.461 26.49v-9.403h6.412v1.777h-4.275v1.845h3.796v1.737h-3.796v2.266h4.59v1.778h-6.727zM81.511 26.49a47.278 47.278 0 00-1.987-3.189 32.444 32.444 0 00-2.274-2.971v6.16h-2.11v-9.403h1.74c.302.298.635.665 1 1.099.366.434.736.9 1.11 1.397.384.489.763 1 1.137 1.534a67.26 67.26 0 011.055 1.52v-5.55h2.124v9.403H81.51zM93.909 17.087v1.804h-2.864v7.599h-2.137V18.89h-2.864v-1.804h7.865zM104.164 16.978c1.415 0 2.502.249 3.261.746.758.489 1.137 1.294 1.137 2.416 0 1.13-.384 1.949-1.151 2.456-.767.497-1.863.746-3.288.746h-.672v3.148h-2.137v-9.268c.466-.09.959-.153 1.48-.19.52-.036.977-.054 1.37-.054zm.137 1.805a7.94 7.94 0 00-.466.013c-.146.01-.274.018-.384.027v2.714h.672c.739 0 1.297-.1 1.671-.298.375-.2.562-.57.562-1.113 0-.262-.05-.48-.151-.651a.981.981 0 00-.411-.407 1.629 1.629 0 00-.644-.217 4.889 4.889 0 00-.849-.068zM113.296 21.781c0 .462.055.878.165 1.249.118.37.283.692.493.963.219.262.484.466.795.61.31.145.666.218 1.068.218.393 0 .745-.073 1.055-.217a2.12 2.12 0 00.795-.611c.219-.271.383-.592.493-.963.119-.371.178-.787.178-1.249 0-.461-.059-.877-.178-1.248a2.616 2.616 0 00-.493-.963 2.064 2.064 0 00-.795-.625 2.467 2.467 0 00-1.055-.217c-.402 0-.758.077-1.068.231a2.206 2.206 0 00-.795.624c-.21.263-.375.584-.493.964-.11.37-.165.782-.165 1.234zm7.248 0c0 .805-.123 1.516-.37 2.13a4.36 4.36 0 01-.986 1.534c-.42.407-.923.714-1.507.922a5.446 5.446 0 01-1.864.313c-.648 0-1.26-.104-1.836-.313a4.278 4.278 0 01-1.507-.922 4.435 4.435 0 01-1.014-1.533c-.246-.615-.37-1.326-.37-2.13 0-.806.128-1.511.384-2.117a4.552 4.552 0 011.028-1.547c.438-.416.94-.728 1.507-.936a5.275 5.275 0 011.808-.312c.649 0 1.261.104 1.836.312.576.208 1.078.52 1.507.936.43.416.768.932 1.014 1.547.247.606.37 1.311.37 2.116zM126.477 16.978c1.425 0 2.517.253 3.275.76.758.497 1.137 1.275 1.137 2.334 0 .66-.155 1.198-.466 1.614-.301.407-.74.729-1.315.964.192.235.393.506.603.814.21.298.415.615.616.95.21.325.411.669.603 1.03.192.354.37.702.534 1.046h-2.397c-.174-.308-.352-.62-.535-.937a15.013 15.013 0 00-.548-.922 16.307 16.307 0 00-.548-.841 8.37 8.37 0 00-.548-.733h-1.055v3.433h-2.137v-9.268c.466-.09.945-.153 1.438-.19.503-.036.95-.054 1.343-.054zm.123 1.805a6.01 6.01 0 00-.424.013l-.343.027v2.551h.603c.804 0 1.379-.1 1.726-.298.347-.2.521-.538.521-1.018 0-.461-.178-.787-.534-.977-.347-.199-.863-.298-1.549-.298zM141.113 17.087v1.804h-2.864v7.599h-2.137V18.89h-2.863v-1.804h7.864zM149.09 26.49c-.1-.326-.215-.66-.342-1.005l-.357-1.03h-3.699c-.119.343-.242.687-.37 1.03a32.53 32.53 0 00-.329 1.005h-2.219a161.9 161.9 0 011.014-2.81c.319-.858.63-1.668.931-2.428.311-.76.612-1.479.905-2.157.301-.688.612-1.357.931-2.008h2.042a72.648 72.648 0 011.822 4.165c.311.76.626 1.57.945 2.429.32.86.658 1.796 1.014 2.809h-2.288zm-2.562-7.273a14.7 14.7 0 01-.205.556l-.316.814c-.118.308-.251.647-.397 1.018-.137.37-.279.76-.425 1.167h2.699c-.146-.407-.287-.796-.424-1.167-.137-.37-.27-.71-.398-1.018a137.292 137.292 0 00-.534-1.37zM160.321 24.671v1.819h-6.344v-9.403h2.138v7.584h4.206z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43
    },
    __self: this
  })), _defs || (_defs = React.createElement("defs", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47
    },
    __self: this
  }, React.createElement("linearGradient", {
    id: "prefix__paint0_linear_5535_35391",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48
    },
    __self: this
  }, React.createElement("stop", {
    stopColor: "#F7F7F7",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56
    },
    __self: this
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57
    },
    __self: this
  })), React.createElement("clipPath", {
    id: "prefix__clip0_5535_35391",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59
    },
    __self: this
  }, React.createElement("path", {
    fill: "#fff",
    transform: "translate(6.4 4.8)",
    d: "M0 0h19.2v22.8H0z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60
    },
    __self: this
  })))));
}

var _default = ReactComponent;
exports["default"] = _default;